import './App.css';
import { Routes, Route, Link } from 'react-router-dom';
import Games from './pages/Games';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
  return (
    <div className="App">
      <nav className="nav">
        <div className="nav-inner">
          <Link to="/" className="nav-brand">Ilia Stasik</Link>
          <div className="nav-links">
            <Link to="/">Games</Link>
            <Link to="/about">About</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
      </nav>

      <main className="container">
        <Routes>
          <Route path="/" element={<Games />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>

      <footer className="footer">
        <div>© {new Date().getFullYear()} Ilia Stasik</div>
      </footer>
    </div>
  );
}

export default App;
